<template>
  <div>
    <div class="col-sm-12 col-xl-6">
      <div class="form-card h-100 p-4">
        <h6 class="mb-4">Add Exchange</h6>
        <form @submit.prevent="onSubmit">
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.name"
              name="name"
              class="form-control"
              id="name"
              placeholder="Exchange Name"
            />
            <label for="name">Name</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.code"
              name="code"
              class="form-control"
              id="code"
              placeholder="Code"
            />
            <label for="code">Code</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.yahoo_code"
              name="yahoo_code"
              class="form-control"
              id="yahoo_code"
              placeholder="Yahoo Code"
            />
            <label for="yahoo_code">Yahoo Code</label>
          </div>
          <div class="form-floating mb-3">
            <button :disabled="v$.form.$invalid" type="submit" @click="addNewExchange()" class="btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <ReportTable title="Sector" :fields='exchangeFields' :data ='exchangeList'/>
  </div>
</template>
  
  <script>
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import { useAlertStore } from '@/stores';
  
  import ReportTable from '@/components/Report/Table.ce.vue';
  import { fetchWrapper } from '@/helpers';

  export default {
    name: "add-exchange",
    components: {
      ReportTable
    },
    setup() {
      return { 
        v$: useVuelidate(),
        alertStore$: useAlertStore(),
       };
    },
    data() {
      return {
        form: {
          name: "",
          code: "",
          yahoo_code: "",
        },
        exchangeList: [],
        exchangeFields: 
        {
          'exchange_id' : {
            'text' : 'Exchange Id',
            'type' : 'number',
          },
          'name' : {
            'text' : 'Name',
            'type' : 'text', 
          },
          'code' : {
            'text' : 'Code',
            'type' : 'text', 
          },
          'yahoo_code' : {
            'text' : 'Yahoo Code',
            'type' : 'text', 
          },
        }
      };
    },
    validations() {
      return {
        form: {
          name: { required },
          code: { required },
        },
      };
    },
    methods: {
      addNewExchange() {
        try {
          fetchWrapper.post('api/exchange/add-new', this.form)
            .then((response) => {
                if(response.data.success){
                  this.alertStore$.success('New Exchange add successfully.');   
                  this.exchangeList.push(response.data.data);
                } else {
                  this.alertStore$.error(response.message);
                }
            })
          } catch (error) {
              console.log(error);
          }
      },
      getExchange(){
        fetchWrapper.post('api/exchange')
          .then((response) => {
            this.exchangeList = response.data;
        })
      },
    },
    mounted() {
      this.getExchange();
    },
  };
  </script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>